export default "__VITE_ASSET__1721dd0a__"